import VueRouter from 'vue-router'
// import Main from './components/Main.vue'
// import Login from './components/Login.vue'
// import ResetPassword from './components/Usuario/ResetPassword.vue'
// import Usuario from './components/Usuario/Usuario.vue'
// import Pedido from './components/Pedido/Pedido.vue'
import store from './store'
import { getMe } from './services/usuario'

const routes = [
  { path: '/', component: () => import('./components/Main.vue'), name: 'Main', meta: { requiresAuth: true, label: 'Início' } },
  { path: '/login', component: () => import('./components/Login.vue'), name: 'Login', meta: { requiresAuth: false, label: 'Login' } },
  { path: '/resetPassword', component: () => import('./components/Usuario/ResetPassword.vue'), name: 'Reset Password', meta: { requiresAuth: false, label: 'Redefinição de senha' } },
  { 
    path: '/usuario',
    component: () => import('./components/Usuario/Usuario.vue'),
    name: 'Usuario',
    meta: { requiresAuth: true, label: 'Usuários' }
  },
  { 
    path: '/cliente/pedidos',
    component: () => import('./components/Pedido/Pedido.vue'),
    name: 'Pedido',
    meta: { requiresAuth: true, label: 'Pedidos' }
  },
  { 
    path: '/pesquisas',
    component: () => import('./components/Pesquisa/Pesquisa.vue'),
    name: 'Pesquisas',
    meta: { requiresAuth: true, label: 'Pesquisas' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  document.title = `SRCAL - ${to.meta.label}`
  const token = store.getters.getToken
  if (to.name === 'Login' && token) return next({ name: 'Main' })
  if (!to.meta.requiresAuth) return next()
  if (!token) {
    if (from.path === '/login') return next({ name: 'Login' })
    if (from.path !== '/login') {
      return next({ name: 'Login' })
    }
  } else {
    // const usuario = store.getters.getUsuario
    const { token, ...usuario } = await getMe()
    store.dispatch('setUsuario', usuario)
    store.dispatch('setToken', token)
    // if (!usuario.cpf) {
    //   const { token, ...usuario } = await getMe()
    //   store.dispatch('setUsuario', usuario)
    //   store.dispatch('setToken', token)
    // }
  }
  next()
})

export default router